import { render, staticRenderFns } from "./OrgUserList.vue?vue&type=template&id=3d5c882d"
import script from "./OrgUserList.vue?vue&type=script&lang=js"
export * from "./OrgUserList.vue?vue&type=script&lang=js"
import style0 from "./OrgUserList.vue?vue&type=style&index=0&id=3d5c882d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports